import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  constructor(private router: Router) {}

  handleError(error: HttpErrorResponse) {
    // Always log so failures are visible. Previously a 401 immediately called
    // document.location.reload(), which wiped the console (and could loop),
    // making it impossible to see what actually failed.
    console.error(
      `API error ${error.status} on ${error.url ?? 'unknown url'}:`,
      error.error ?? error.message
    );

    if (error.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('authToken:token');
      // Redirect to login through the router (SPA) instead of a hard page
      // reload, so the console is preserved and repeated 401s don't loop.
      this.router.navigate(['/auth/login']);
    }
    throw error;
  }
}
